import extendNode from '../extendNode.mjs'
import useCategoryNode from '../_CATEGORY/useCategoryNode.jsx'
import meta from './metaVrDeployedOn.mjs'

export default () => {
    const CategoryNode = useCategoryNode()

    return extendNode(CategoryNode, {
        ...meta,

        _getCategories(map, node) {
            return [
                'VR_DEPLOYED_SSINS',
                'VR_DEPLOYED_DBINS',
                'VR_DEPLOYED_MIDINS',
            ]
        },
    })
}
